module.exports = __webpack_public_path__ + "img/IMG-20181104-WA0016.3f74f2db.jpg";